import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableLoaderComponent } from './table-loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    TableLoaderComponent
  ],
  imports: [
    CommonModule,NgxSkeletonLoaderModule.forRoot({
      theme: {
        // Enabliong theme combination
        extendsFromRoot: true,
        // ... list of CSS theme attributes
        height: '30px',
        width: '100%',
        margin: '10px 0px'
      },
    }),BrowserModule, FormsModule,
  ],
  exports: [TableLoaderComponent]
})
export class TableLoaderModule { }
